import { Component, Inject, OnInit, ViewChild } from '@angular/core';
import {
  MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,
  MatLegacyDialogRef as MatDialogRef,
} from '@angular/material/legacy-dialog';
import * as _ from 'lodash';
import { Observable, map, take, tap, timer } from 'rxjs';
import { SvgWorkspaceComponent } from '../../../components/svg-workspace/svg-workspace.component';

import { AngleProcessingAvailability } from 'cloud-shared-lib';
import { AnglePosition } from '../../../models/cutting/cutting-panel-outline.model';
import { FacadeView } from '../../../models/cutting/facade-view.model';
import { OutlineEditorOptions } from '../../../models/user/outline-editor-options.model';
import { FacadeSettingsStateService } from '../facade-settings-state.service';
import { FacadesAvailableComponentsService } from '../facades-available-components.service';

export interface AngleProcessingDialogData {
  angle: AnglePosition;
  angleProcessingAvailability: AngleProcessingAvailability;
  outlineEditorOptions: OutlineEditorOptions;
}

@Component({
  templateUrl: './angle-processing-dialog.component.html',
})
export class AngleProcessingDialogComponent implements OnInit {
  @ViewChild('svgWorkspace') svgWorkspace: SvgWorkspaceComponent;

  panel$: Observable<FacadeView>;

  panel: FacadeView;

  render$: Observable<number>;

  constructor(
    private facadeSettingsService: FacadeSettingsStateService,
    private dialog: MatDialogRef<AngleProcessingDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: AngleProcessingDialogData,
    public facadesAvailableComponentsService: FacadesAvailableComponentsService
  ) {
    this.panel$ = this.facadeSettingsService.panel$.pipe(
      take(1),
      map(p => _.cloneDeep(p)),
      tap((p: FacadeView) => (this.panel = p))
    );
  }

  save(panel: FacadeView): void {
    this.dialog.close({
      topRight: panel.panelOutline.topRight,
      bottomRight: panel.panelOutline.bottomRight,
      bottomLeft: panel.panelOutline.bottomLeft,
      topLeft: panel.panelOutline.topLeft,
    });
  }

  ngOnInit(): void {
    /* TODO: Т к раньше это делалось в ngAfterViewChecked, это очень перегружало основной поток и вызывало циклические рендеры,
     * чтобы ничего не поломать и снизить нагрузку добавлен этот костыль,
     * но перерисовку все равно необходимо переделать, чтобы схема перерисовывалась только при реальных изменениях в панели
     */
    this.render$ = timer(0, 1000).pipe(
      tap(() => {
        this.redraw();
      })
    );
  }

  redraw(): void {
    this.svgWorkspace?.draw(this.panel);
  }
}
